import store from '@/stores'

export default (to, from, next) => {
  const user = store.state.authStore.userData

  if (!user || user.role === 'user') {
    store.dispatch('alertStore/addAlert', {
      type: 'warning',
      message: `Could not send you to ${to.path} as you are not an admin or part of this organization.`,
    })
    return next('/')
  }

  if (user.role === 'lender' && (!user.organization || user.organization.hidden)) {
    store.dispatch('alertStore/addAlert', {
      type: 'warning',
      message: 'This organization has been temporarily disabled.',
    })
    return next('/')
  }

  return next()
}
